import { useAuthStore } from '@/store/useAuthStore'
import { Paths } from '@/routes/paths'
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from '@/components/ui/dialog'
import { Button } from '@/components/ui/button'
import { useNavigate } from '@tanstack/react-router'

export const SessionExpiredModal = () => {
  const navigate = useNavigate()
  const showSessionExpired = useAuthStore((state) => state.showSessionExpired)
  const setShowSessionExpired = useAuthStore((state) => state.setShowSessionExpired)

  const handleLogout = () => {
    useAuthStore.getState().logout()
    setShowSessionExpired(false)
    navigate({ to: Paths.ManagementLogin })
  }

  return (
    <Dialog open={showSessionExpired} onOpenChange={setShowSessionExpired}>
      <DialogContent className="sm:max-w-md">
        <DialogHeader>
          <DialogTitle>Sesión expirada</DialogTitle>
          <DialogDescription>
            Tu sesión ha expirado por inactividad. Se ha cerrado la sesión automáticamente.
          </DialogDescription>
        </DialogHeader>
        <DialogFooter>
          <Button variant="default" onClick={handleLogout}>
            Iniciar sesión
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  )
}
